<div class="featured-view">
    <div class="bg-container"></div>
    <div class="featured-main">
        <div class="title dark">
            <p class="banner-title">{{title}}</p>
        </div>
        <div class="slider-container">
        <ngx-slick-carousel class="slider-main" [config]="config">
          <shared-product-card ngxSlickItem class="slick-slide" *ngFor="let item of cards" [product]="item" [expandMode]="true">
          </shared-product-card>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>